{
  "version": 1,
  "asset_id": "113a0ba6-5ff4-4417-b459-2c9b1d5cc041",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/113a0ba6-5ff4-4417-b459-2c9b1d5cc041/clip-img_2311.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/113a0ba6-5ff4-4417-b459-2c9b1d5cc041/clip-img_2311.mp4",
  "original_filename": "clip-img_2311.mp4",
  "size": 466707,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:33:06Z"
}
